<script>
  import { roomsState } from '../../js/state.js';
  import { CHAT_PUBLIC_TITLE } from '../../js/l10n/en_US.js';

  export let roomsEnabled = false,
    toggleVisible = () => {};

  let currentRoomName = CHAT_PUBLIC_TITLE;

  $: if ($roomsState) {
    if ($roomsState.current !== null) {
      currentRoomName = $roomsState.current.room_name;
    } else {
      currentRoomName = CHAT_PUBLIC_TITLE;
    }
  }

  function toggleRoomsVisible() {
    if (roomsEnabled) {
      toggleVisible();
    }
  }
</script>

<div class="title-room-select" on:click={toggleRoomsVisible}>
  <i class="icon-chat_bubble_outline" />
  <span>{currentRoomName}</span>
  {#if roomsEnabled}
    <i class="icon-keyboard_arrow_down" />
  {/if}
</div>
